import Vue from 'vue';

import Router from 'vue-router';
import RouterPrefetch from 'vue-router-prefetch';
import Meta from 'vue-meta';
import VueScrollTo from 'vue-scrollto';

Vue.use(Router);
Vue.use(RouterPrefetch);
Vue.use(Meta);

import newsData from '../src/assets/data/news.json';

const router = new Router({
    base: process.env.BASE_URL,

    mode: 'history',

    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            if (to.hash) {
                VueScrollTo.scrollTo(to.hash, {
                    duration: 700
                });
                return {selector: to.hash};
            } else {
                return {x: 0, y: 0};
            }
        }
    },

    routes: [
        {
            path: '/',
            name: 'home',
            component: () => import(/* webpackChunkName: "home" */ './views/Home.vue')
        },
        {
            path: '/assets/:category/:id',
            name: 'assets',
            component: () => import(/* webpackChunkName: "assets" */ './views/Assets.vue'),
            props: true
        },
        {
            path: '/career',
            name: 'career',
            component: () => import(/* webpackChunkName: "career" */ './views/Career.vue')
        },
        /* {
            path: '/jobs',
            redirect: '/career'
        }, */
        // {
        //     path: '/internship',
        //     name: 'internship',
        //     component: () => import(/* webpackChunkName: "internship" */ './views/Internship.vue')
        // },
        {
            path: '/we',
            name: 'we',
            component: () => import(/* webpackChunkName: "we" */ './views/We.vue')
        },
        {
            path: '/privacy-policy',
            name: 'policy',
            component: () => import(/* webpackChunkName: "we" */ './views/Policy.vue')
        },
        {
            path: '/vacancy/:id',
            name: 'vacancy',
            component: () => import(/* webpackChunkName: "vacancy" */ './views/Vacancy.vue'),
            props: true
        },
        {
            path: '/clients',
            name: 'clients',
            component: () => import(/* webpackChunkName: "clients" */ './views/Clients.vue'),
            props: true
        },
        {
            path: '/technologies/',
            redirect: {
                name: 'technologies',
                props: {category: 'bigdata', id: 'b2b'}
            }
        },
        {
            path: '/technologies/:category',
            redirect: {
                name: 'technologies',
                props: {category: 'bigdata', id: 'b2b'}
            }
        },
        {
            path: '/technologies/:category/:id',
            name: 'technologies',
            component: () => import(/* webpackChunkName: "technologies" */ './views/Technologies.vue'),
            props: true
        },
        {
            path: '/news',
            name: 'newslist',
            component: () => import(/* webpackChunkName: "newslist" */ './views/NewsList.vue')
        },
        {
            path: '/newstest',
            name: 'newslisttest',
            component: () => import(/* webpackChunkName: "newslisttest" */ './views/NewsListTest.vue')
        },
        /* {
            path: '/live',
            redirect: '/news'
        }, */
        {
            path: '/news/:id',
            name: 'news',
            component: () => import(/* webpackChunkName: "news" */ './views/News.vue'),
            props: true,
            beforeEnter: (to, from, next) => {
                if (newsData.list.find(el => el.id === to.params.id).hidden) {
                    next('/news');
                } else {
                    next();
                }
            }
        },
        {
            path: '/newstest/:id',
            name: 'newstest',
            component: () => import(/* webpackChunkName: "newstest" */ './views/NewsTest.vue'),
            props: true
        },
        {
            path: '/contacts',
            name: 'Contacts',
            component: () => import(/* webpackChunkName: "contacts" */ './views/Contacts.vue')
        }
    ]
});

export default router;
